import * as React from 'react';
import {
  MasonryGridLayoutRenderer,
  MasonryGridLayoutRendererProps,
} from '@leagueplatform/masonry-renderers';

export const NODE_TYPE_GRID_LAYOUT = 'gridLayout';

export const GridLayoutRenderer = (
  props: MasonryGridLayoutRendererProps,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <MasonryGridLayoutRenderer {...props} />;
